<template>
    <div>
        <banner :banner="banner"></banner>
        <!-- <div class="cates">
            <div class="catesCon">
                <div class="cateItem flx">
                    <div class="cateName">选择类别</div>
                    <div class="cateCon flx">
                        <div @click="scanThis(0,0)" :class="cateId == 0?'cactive' : ''" class="caItem cursor">
                            全部
                        </div>
                        <div @click="scanThis(i,v.id)" :class="cateId == v.id?'cactive' : ''" class="caItem cursor"
                            v-for="v,i in cates" v-text="v.name"></div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="coaches flx">
            <div class="coachItem" :class="(index + 1) % 6 == 0?'mar0' :'mar24'"v-for="item,index in list" @click="toDetail(item)">
                <div class="coachImg">
                    <img :src="$img(item.avatar)" alt="" />
                </div>
                <div class="coachInfo">
                    <div class="coachName multy2" v-text="item.goods_name"></div>
                    <div class="price-wrap" style="text-align: left;">
                        <!-- 价格组件 -->
                        <span class="price-box">
                            <span>¥</span>
                            <span class="int">{{p(item.default_goods_price,0) }}</span>
                            <span class="dec">{{p(item.default_goods_price,1) }}</span>
                        </span>
                    </div>
                    <div class="booktips single" v-text="item.title"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getbooksCate,
        getBookList
    } from "@/api/index.js"
    import banner from "@/components/banner.vue"
    export default {
        name: "index",
        components: {
            banner
        },
        data() {
            return {
                banner: [],
                cates: [],
                cateId: '0',
                list: []
            };
        },
        created() {
            this.getBanner()
        },
        methods: {
            p(e, d) {
                const s = Number(e).toFixed(2).split('.')
                let p = {}
                p.int = s[0]
                p.dec = '.' + s[1]
                return d == 0 ? s[0] : '.' + s[1]
            },
            toDetail(d) {
                let that = this
                this.$router.push({
                    path: '/bookDetail', // 写路由path
                    query: {
                        id: d.goods_id
                    }
                })
            },
            getBanner() {
                let that = this
                getbooksCate().then((res) => {
                    console.log('cate', res)
                    if (res.code == 1) {
                        that.banner = res.data.category[0].banner
                        that.cates = res.data.category
                        that.getList()
                    }

                })
            },
            getList() {
                let that = this
                let data = {}
                data.category_id = that.cateId
                data.page = that.page
                data.size = 30
                getBookList(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.list = res.data.data
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            },
            scanThis(index, id) {
                let that = this
                that.page = 1
                that.cateId = id
                that.banner = that.cates[index].banner
                that.getList()
            }
        }
    };
</script>

<style scoped>
    .mar0{
        margin-right: 0;
    }
    .mar24{
        margin-right: 24px;
    }
    .booktips{
        font-weight: 500;
        font-size: 12px;
        color: #9CA3AF;
        margin-top: 6px;
        text-align: left;
    }
    .price-box {
        display: inline-flex;
        align-items: baseline;
        color: #FF0F23;
        justify-content: flex-start;
    }

    .int {
        font-size: 22px;
        font-weight: bold;
    }

    .dec {
        font-size: 17px;
    }

    .checknow {
        width: 104px;
        height: 36px;
        background: linear-gradient(90deg, #4A9EFF 0%, #1E7FE5 100%);
        box-shadow: 0px 2px 6px 0px rgba(30, 127, 229, 0.25);
        border-radius: 18px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #FFFFFF;
    }

    .priceNum {
        color: #EF4444;
        font-size: 16px;
        margin-left: 8px;
        font-weight: bold;
    }

    .priceName {
        font-weight: bold;
        color: #000;
        font-size: 16px;
    }

    .coachDes {
        font-weight: 500;
        margin-bottom: 8px;
        font-size: 14px;
        color: #9CA3AF;
        line-height: 24px;
        text-align: left;
        margin-top: 8px;
    }

    .label {
        height: 19px;
        box-sizing: border-box;
        padding: 0 5px;
        font-size: 12px;
        color: #007AFF;
        background: #F4F9FF;
        border-radius: 1px 1px 1px 1px;
        line-height: 19px;
        margin-right: 8px;
    }

    .coachName {
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        text-align: left;
        margin-bottom: 8px;
    }

    .coachInfo {
        box-sizing: border-box;
        padding: 12px;
    }

    .coachImg {
        width: 221px;
        height: 220px;
        position: relative;
        cursor: pointer;
        overflow-y: hidden;
    }

    .tag {
        background: linear-gradient(79deg, #F59E0B 0%, #F4870A 100%);
        box-shadow: 0px 2px 8px 0px rgba(255, 71, 87, 0.35);
        height: 30px;
        line-height: 30px;
        border-radius: 15px 15px 15px 2px;
        font-weight: 600;
        font-size: 13px;
        color: #FFFFFF;
        text-align: center;
        box-sizing: border-box;
        padding: 0 11px;
        position: absolute;
        top: 12px;
        left: 12px;
    }

    .coachImg img {
        width: 100%;
        /* height: 100%; */

    }

    .coachItem {
        width: 222px;
        height: 350px;
        background: #fff;
        flex-shrink: 0;
        border-radius: 12px;
        margin-bottom: 20px;
        overflow: hidden;
    }

    .coaches {
        width: 1460px;
        margin: 0 auto;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 20px 0;
    }

    .cactive {
        font-weight: 500 !important;
        color: #007AFF !important;
    }

    .caItem {
        margin-right: 40px;
        font-size: 14px;
        color: #4E5366;
        margin-bottom: 12px;
    }

    .cateCon {
        flex: 1;
        flex-wrap: wrap;
    }

    .cateName {
        font-weight: 600;
        font-size: 14px;
        color: #222222;
        margin-right: 40px;
    }

    .catesCon {
        width: 1460px;
        margin: 0 auto;
    }

    .cateItem {
        padding: 10px 0;
    }

    .cates {
        width: 100%;
        background: #fff;
        box-sizing: border-box;
        padding: 12px 0;
    }
</style>